import i18n from '../i18n';
import type { SportContext } from './sportContext';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const tt = (key: string, opts?: Record<string, unknown>) => (i18n as any).t(key, opts);
const t = (key: string, opts?: Record<string, unknown>) => tt(`onboarding:${key}`, opts);

export function getCoachTour(ctx: SportContext) {
  const c = ctx.copy;
  return [
    {
      target: '[data-onboarding="dashboard-main"]',
      title: tt('nav:home'),
      content: c.coachTourDashboard,
      placement: 'bottom',
      skipBeacon: true
    },
    {
      target: '[data-onboarding="nav-students"]',
      title: c.coachTourStudentsTitle,
      content: c.coachTourStudents,
      placement: 'right',
      skipBeacon: true
    },
    {
      target: '[data-onboarding="nav-schedule"]',
      title: tt('nav:schedule'),
      content: c.coachTourSchedule,
      placement: 'right',
      skipBeacon: true
    },
    {
      target: '[data-onboarding="nav-attendance"]',
      title: tt('nav:attendance'),
      content: c.coachTourAttendance,
      placement: 'right',
      skipBeacon: true
    },
    {
      target: '[data-onboarding="nav-upload"]',
      title: tt('nav:video'),
      content: c.coachTourVideo,
      placement: 'right',
      skipBeacon: true
    }
  ];
}

export function getCoachChecklist(ctx: SportContext) {
  return [
    {
      key: 'view_schedule',
      label: t('coachChecklistViewSchedule'),
      description: t('coachChecklistViewScheduleDesc', { example: ctx.scheduleExample }),
      route: '/schedule'
    },
    {
      key: 'mark_attendance',
      label: t('coachChecklistMarkAttendance'),
      description: t('coachChecklistMarkAttendanceDesc'),
      route: '/attendance'
    },
    {
      key: 'review_students',
      label: t('coachChecklistReviewStudents'),
      description: t('coachChecklistReviewStudentsDesc'),
      route: '/students'
    },
    {
      key: 'upload_video',
      label: t('coachChecklistUploadVideo'),
      description: t('coachChecklistUploadVideoDesc'),
      route: '/upload'
    }
  ];
}

export function getCoachWelcome() {
  return {
    subtitle: t('welcomeCoachSubtitle'),
    startLabel: t('welcomeStartTour')
  };
}

export function getCoachChecklistUi() {
  return {
    title: t('checklistCoachTitle'),
    doneTitle: t('checklistCoachDone'),
    doneMessage: t('coachChecklistDoneMessage'),
    doneButton: t('coachChecklistDoneButton'),
    doneRoute: '/attendance'
  };
}

